import { Checkbox, CheckboxProps } from "antd"
import styled from "styled-components"

const CheckBoxStyle: React.FunctionComponent<CheckboxProps> = styled(Checkbox)`
  .ant-checkbox-inner {
    height: 18px;
    width: 18px;
    border: 1.5px solid ${(props) => props.theme.colorbluegrey};
    border-radius: 4px;
    background-color: transparent;
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${(props) => props.theme.primary};
      border-color: transparent;
      &:after {
        border-color: ${(props) => props.theme.textcolordwhite3};
      }
    }
  }
`

export default CheckBoxStyle
